import styled from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
const transitionDuration = '200ms';
const buttonMargin = 24;
export const Container = styled.div `
    width: 100%;
    box-sizing: border-box;
    height: ${({ isMobileFactor }) => (isMobileFactor ? '180px' : '320px')};
    flex-direction: column;
    justify-content: flex-end;
    margin: 0 auto;
    padding: 0 48px;
    display: ${({ shouldBeHidden }) => (shouldBeHidden ? 'none' : 'flex')};
    > * {
        // Setting pointer-events to auto so it works over embedded ad UI
        pointer-events: auto;
    }
    @media (max-width: 800px) {
        height: 180px;
    }
    flex: 1;
`;
export const Time = styled.span.withConfig(testableStyledComponentConfig) `
    color: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textSecondary; }};
    transition: opacity ${transitionDuration}, visibility ${transitionDuration};
    opacity: ${({ isVolumeOpened }) => (isVolumeOpened ? 0 : 1)};
    visibility: ${({ isVolumeOpened }) => (isVolumeOpened ? 'hidden' : 'visible')};
`;
export const FooterStart = styled.div `
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;
FooterStart.displayName = 'FooterStart';
export const FooterMiddle = styled.div `
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-around;
`;
FooterMiddle.displayName = 'FooterMiddle';
export const FooterEnd = styled.div `
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
`;
FooterEnd.displayName = 'FooterEnd';
export const RemainingTimeContainer = styled.div `
    width: 100px;
    display: flex;
    justify-content: flex-end;
    flex: 1;
`;
RemainingTimeContainer.displayName = 'RemainingTimeContainer';
export const ElapseTimeContainer = styled.div `
    width: 100px;
    display: flex;
    justify-content: flex-start;
    flex: 1;
`;
ElapseTimeContainer.displayName = 'ElapseTimeContainer';
export const rightMarginButtonStyles = {
    button: {
        marginRight: buttonMargin,
    },
};
export const leftMarginButtonStyles = {
    button: {
        marginLeft: buttonMargin,
    },
};
//# sourceMappingURL=index.js.map